import { NotificationFlagsCategories } from "../../models/NotificationFlags/NotificationFlagsCategories";

export class PmgNotificationFlagsHelper {
    public static generateClubRoomNotificationFlag = (groupId: number) =>
        `${NotificationFlagsCategories.PmgCode}.${groupId}.${NotificationFlagsCategories.ClubRoomCode}`;
}
